// extracted by mini-css-extract-plugin
export var list = "timeline-list-module--list--IOwVl";